import React from "react";
import Post from "../../lib/Pages/Post";

function PostPage() {
  return <Post />;
}

export default PostPage
